import React from "react";

const LoadingBar = ({ height, width, color }) => {
  return (
    <div
      className={`${height ?? "h-full"} ${width ?? "w-full"} ${
        color ?? "bg-gray-500 "
      } animate-pulse rounded-md`}
    />
  );
};

export default LoadingBar;
